import { Injectable, EventEmitter } from "@angular/core";
import { IFrameWorkEmitObject } from "@mmortgage/dynamic-form";
import { FormUtlityCommanFunction } from "@mmortgage/dynamic-form";
import { localTempObject } from "@mmortgage/dynamic-form";

@Injectable()
export class FormPostScriptFunctions {
    private onPostScriptCompleteEmit: EventEmitter<IFrameWorkEmitObject>
        = new EventEmitter<IFrameWorkEmitObject>();
    private postScriformUliFunObj: FormUtlityCommanFunction;
    private postScritempLocalObj: localTempObject;
    private parentObj: any;
    private EnumData: any;

    setPostScriptIntValues(commFun: FormUtlityCommanFunction,
        tempObj: localTempObject, parentObj: any, enumObj: any) {
        this.postScriformUliFunObj = commFun;
        this.postScritempLocalObj = tempObj;
        this.parentObj = parentObj;
        this.EnumData = enumObj;
    }

    onPostSrciptComplete(obj: IFrameWorkEmitObject) {
        try {
            this.onPostScriptCompleteEmit.emit(obj);
        } catch (e) {
            this.postScriformUliFunObj.displayErrorInConsole('Error - > onPostSrciptComplete ::: Function in  - > form-preScript-function.ts', e)
        }
    }

    onPostScriptCompleteInFramework() {
        try {
            return this.onPostScriptCompleteEmit;
        } catch (e) {
            this.postScriformUliFunObj.displayErrorInConsole('onPostScriptCompleteInFramework ---> form-flow_framework.ts', e);
        }
    }


}